/** Shared desktop geometry for the workspace header and its edge-to-edge left sidebar. */
export const DESKTOP_CANVAS_SIDEBAR_LEFT_PX = 0;
export const DESKTOP_CANVAS_SIDEBAR_WIDTH_PX = 260;
export const DESKTOP_CANVAS_SIDEBAR_WIDTH_CSS = 'var(--workspace-panel-width, 260px)';
export const GLOBAL_NAVIGATION_RAIL_WIDTH_PX = 64;
export const GLOBAL_NAVIGATION_EXPANDED_WIDTH_PX = 224;
export const GLOBAL_NAVIGATION_MIN_EXPANDED_WIDTH_PX = 200;
export const GLOBAL_NAVIGATION_MAX_WIDTH_PX = 360;
export const GLOBAL_NAVIGATION_COLLAPSE_THRESHOLD_PX = 132;
export const GLOBAL_NAVIGATION_WIDTH_CSS = 'var(--global-navigation-width, 224px)';
export const DESKTOP_PROJECT_NAVIGATION_HEIGHT_PX = 52;
export const FOCUS_MODE_CONTENT_MAX_WIDTH_PX = 940;

/** Messages and composer share a width; the full conversation workspace can expand it. */
export const CONVERSATION_CONTENT_COLUMN_CLASS_NAME = 'mx-auto w-full max-w-[var(--conversation-column-width,760px)]';

/** Keep every project view's utility stack centered on the same desktop anchor. */
export const PROJECT_RIGHT_RAIL_LAYOUT =
  'absolute right-[17px] top-1/2 z-20 -translate-y-1/2 flex-col items-center gap-2';

/** Same composer card width and rail clearance in all three project modes. */
export const PROJECT_COMPOSER_COLUMN_CLASS_NAME = `${CONVERSATION_CONTENT_COLUMN_CLASS_NAME} px-3`;
export const PROJECT_COMPOSER_RAIL_PX = 76;
export function projectComposerInsets(isMobile: boolean, sidebarExpanded: boolean) {
  return { left: isMobile || sidebarExpanded ? 0 : PROJECT_COMPOSER_RAIL_PX,
    right: isMobile ? 0 : PROJECT_COMPOSER_RAIL_PX };
}
